import { Observable, fromEvent, merge } from 'rxjs'
import { FromEventTarget } from 'rxjs/internal/observable/fromEvent'

export type FromEventsResult<TMap extends {}> = Observable<TMap[keyof TMap]>

export const fromEvents = <EventsMap extends Record<string, any>> (source: FromEventTarget<any>, events: (keyof EventsMap)[]) => {
  const eventSources = events.map((event) => {
    return fromEvent<EventsMap[typeof event]>(source, event as string)
  })
  return merge(...eventSources) as FromEventsResult<EventsMap>
}
